import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "type", "size", "disabled", "value", "buttonType", "onValueChange", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file CheckboxGroup 复选按钮组
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import React, { useMemo } from 'react';
import { useRefCallback } from '@tencent/glue-react-use';
import { GroupProvider, useGroup } from '@tencent/glue-react-group';
import { ViewCheckGroup } from '../../views/ViewCheckGroup';
import { Button } from '../Button';
export function CheckGroup(props) {
  var name = props.name,
      type = props.type,
      size = props.size,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      propsValue = props.value,
      buttonType = props.buttonType,
      onValueChange = props.onValueChange,
      children = props.children,
      extra = _objectWithoutProperties(props, _excluded);

  var value = useMemo(function () {
    return propsValue || [];
  }, [propsValue]);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var extraProps = type === 'button' ? {
    type: buttonType,
    size: size,
    name: name
  } : {
    name: name
  };
  var group = useGroup({
    disabled: disabled,
    value: value,
    onChange: onValueChangeCallback,
    extraProps: extraProps
  });
  return React.createElement(GroupProvider, {
    value: group
  }, React.createElement(ViewCheckGroup, _objectSpread(_objectSpread({}, extra), {}, {
    type: type,
    disabled: disabled
  }), type === 'button' ? React.createElement(Button.Group, null, children) : children));
}